import { useNavigate } from "react-router-dom";
import { Phone, ArrowLeft, ShieldCheck } from "lucide-react";
import CallbackForm from "@/components/CallbackForm";

const telHref = (phone) => `tel:${(phone || "+393514269681").replace(/\s+/g, "")}`;

// Shown instead of payment when bookings require phone verification (no way to confirm from here)
export default function PhoneVerifyDialog({ open, phone, requestId, ensureRequestId, onClose }) {
  const nav = useNavigate();
  if (!open) return null;
  return (
    <div data-testid="phone-verify-dialog" role="dialog" aria-modal="true" aria-labelledby="pv-title" className="fixed inset-0 z-[90] bg-black/75 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in duration-300">
      <div className="relative w-full max-w-lg max-h-[92vh] overflow-y-auto bg-[#0e0e0e] border border-[#22ff66]/40 text-white p-6 md:p-9 shadow-[0_30px_80px_-20px_rgba(34,255,102,0.35)] animate-in zoom-in-95 duration-300">
        <div className="w-12 h-12 rounded-full bg-[#22ff66]/15 flex items-center justify-center mb-5"><ShieldCheck className="w-6 h-6 text-[#22ff66]" /></div>
        <h2 id="pv-title" className="font-display font-black uppercase text-2xl md:text-3xl leading-tight mb-5">Verifica disponibilità e offerte</h2>
        <div className="space-y-3 text-sm md:text-base text-white/80 leading-relaxed mb-6">
          <p>Gentile cliente,</p>
          <p>stiamo aggiornando le nostre tariffe per offrirti condizioni di noleggio sempre più vantaggiose.</p>
          <p>Prima di confermare la tua prenotazione, ti invitiamo a contattarci telefonicamente per verificare la disponibilità effettiva del veicolo, le tariffe aggiornate e le offerte attualmente disponibili.</p>
          <p className="font-semibold text-white">Contattaci telefonicamente per completare la tua richiesta.</p>
        </div>
        <CallbackForm requestId={requestId} ensureRequestId={ensureRequestId} />
        <div className="flex flex-col sm:flex-row gap-3">
          <a data-testid="phone-verify-call" href={telHref(phone)} className="w-full sm:flex-1 shrink-0 inline-flex items-center justify-center gap-2 h-12 px-4 bg-[#22ff66] text-black rounded-full text-xs uppercase tracking-widest font-bold hover:-translate-y-0.5 transition-transform">
            <Phone className="w-4 h-4" /> Chiama Utile Rent
          </a>
          <button type="button" data-testid="phone-verify-back" onClick={() => { onClose?.(); nav("/noleggio/breve"); }} className="w-full sm:flex-1 shrink-0 inline-flex items-center justify-center gap-2 h-12 px-4 border border-white/25 hover:border-white rounded-full text-xs uppercase tracking-widest font-bold transition-colors">
            <ArrowLeft className="w-4 h-4" /> Torna ai veicoli
          </button>
        </div>
      </div>
    </div>
  );
}

export { telHref };
